import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class ShopDeclareInfoAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getShopDeclareInfoList', {
      url: '/admin/financeData/list',
      name: 'list',
      label: '列表'
    }],
    // ['updateShopDeclareInfo', {
    //   url: '/admin/financeData/shopEdit',
    //   name: 'edit',
    //   label: '编辑店铺申报'
    // }],

     ['exportExcelShopDeclareInfoList', {
      url: '/admin/financeData/exportList',
      name: 'export-excel',
      label: '导出'
    }],
    // ['addShopDeclareInfo', {
    //   url: '/admin/quickReply/add',
    //   name: 'add',
    //   label: '添加店铺申报'
    // }],
    // ['deleteShopDeclareInfo', {
    //   url: '/admin/quickReply/delete',
    //   name: 'delete',
    //   label: '删除店铺申报'
    // }],

  ])
  // 店铺申报列表
  public getShopDeclareInfoList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getShopDeclareInfoList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // // 修改店铺申报
  // public updateShopDeclareInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('updateShopDeclareInfo').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 导出店铺申报
  public exportExcelShopDeclareInfoList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('exportExcelShopDeclareInfoList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }
  // 添加店铺申报
  // public addShopDeclareInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('addShopDeclareInfo').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 删除店铺申报
  // public deleteShopDeclareInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('deleteShopDeclareInfo').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
}